import { useMemo } from "react";
import { useAuth } from "react-oidc-context";

export default function useIsAdmin(adminGroupName = "LexEnergy-Admin") {
    const auth = useAuth();
    const user = auth?.user;

    return useMemo(() => {
        const groups = user?.profile?.["cognito:groups"];
        return Array.isArray(groups) && groups.includes(adminGroupName);
    }, [user, adminGroupName]);
}